import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";
import Navbar from "@/components/boost/Navbar";
import Footer from "@/components/boost/Footer";

const NotFound = () => (
  <div className="relative min-h-screen">
    <Helmet>
      <title>404 — BoostF</title>
      <meta name="robots" content="noindex" />
    </Helmet>
    <Navbar />
    <main className="pt-32 pb-24 relative overflow-hidden">
      <div className="aurora opacity-40" aria-hidden />
      <div className="container-x">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="relative max-w-2xl mx-auto text-center"
        >
          <div
            className="mx-auto font-display font-extrabold leading-none gradient-text-emerald"
            style={{ fontSize: "clamp(8rem, 20vw, 16rem)", letterSpacing: "-0.06em" }}
          >
            404
          </div>
          <div className="chip mx-auto">Page not found</div>
          <h1 className="mt-4 font-display font-bold text-slate-900" style={{ fontSize: "clamp(1.75rem, 3.5vw, 2.5rem)" }}>
            Looks like this store shelf is empty.
          </h1>
          <p className="mt-3 text-slate-600 max-w-md mx-auto">
            The page you&apos;re looking for doesn&apos;t exist. But there&apos;s an entire marathon back home.
          </p>
          <div className="mt-8 flex items-center justify-center gap-3">
            <Link to="/" className="btn-primary">
              <ArrowLeft className="w-4 h-4" /> Back to Home
            </Link>
          </div>
        </motion.div>
      </div>
    </main>
    <Footer />
  </div>
);

export default NotFound;
